import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, FolderOpen, Settings, User, Plus } from 'lucide-react';

interface NavItem {
  path: string;
  icon: React.ReactNode;
  label: string;
}

interface MobileBottomNavProps {
  userType?: 'brand' | 'creator';
}

const MobileBottomNav: React.FC<MobileBottomNavProps> = ({ userType = 'brand' }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const brandNavItems: NavItem[] = [
    { path: '/brand/campaign', icon: <Home />, label: 'Home' },
    { path: '/brand/campaigns', icon: <FolderOpen />, label: 'Campaigns' },
    { path: '/subscription', icon: <Settings />, label: 'Plan' },
  ];

  const creatorNavItems: NavItem[] = [
    { path: '/upload', icon: <Home />, label: 'Home' },
    { path: '/my-submissions', icon: <FolderOpen />, label: 'My Videos' },
    { path: '/account', icon: <User />, label: 'Account' },
  ];

  const navItems = userType === 'brand' ? brandNavItems : creatorNavItems;

  const isActive = (path: string) => {
    return location.pathname === path || location.pathname.startsWith(path + '/');
  };

  return (
    <nav className="mobile-bottom-nav">
      {navItems.map((item) => (
        <button
          key={item.path}
          className={`mobile-nav-item ${isActive(item.path) ? 'active' : ''}`}
          onClick={() => navigate(item.path)}
        >
          {item.icon}
          <span>{item.label}</span>
        </button>
      ))}
    </nav>
  );
};

export default MobileBottomNav;
